import { SelectionState } from "@monolith-forensics/monolith-ui";
import { httpPost } from "../connection";
// Import the concrete types module, not the "@/Features" barrel — a barrel
// import here creates api → Features → ... → api dependency cycles.
import type { GetEvidenceQuery } from "@/Features/Evidence/evidence.api.types";

type ExportMultipleEvidenceCocPDFValues = {
  selectionState: {
    selectionStatus: SelectionState["selectionStatus"];
    selectedItems: SelectionState["selectedRowKeys"];
    excludedItems: SelectionState["excludedRowKeys"];
    totalSelected: SelectionState["totalSelected"];
    query: GetEvidenceQuery;
  };
};

type ExportMultipleEvidenceCocPDFResponse = {
  filename: string;
  signedUrl: string;
};

type ExportMultipleEvidenceCocPDFFn = (
  values: ExportMultipleEvidenceCocPDFValues
) => Promise<ExportMultipleEvidenceCocPDFResponse>;

export const exportMultipleEvidenceCocPDF: ExportMultipleEvidenceCocPDFFn =
  async (values) => {
    return httpPost(`/evidence/bulk-coc/multi-coc-report`, values);
  };
